"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = __importDefault(require("constants/api"));
const constants_1 = require("constants/constants");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const fetch_1 = require("./fetch");
const doLogin = async ({ params, callback, }) => {
    callback.onLoading?.(true);
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "login",
        data: {
            uid: params.user || "",
            pwd: params.password || "",
            tipo: params.tipo,
        },
    }));
    (0, fetch_1.fetchWithTimeout)(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            //Accept: "application/json",
            //"Content-Type": "application/json",
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
        timeout: 120000,
    })
        .then(response => response.json())
        .then((json) => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                //save password
                if (params?.isSavePassword === true) {
                    async_storage_1.default.setItem(constants_1.StorageKey.SAVE_PASSWORD, JSON.stringify({
                        user: params?.user,
                        password: params?.password,
                    }));
                }
                else {
                    async_storage_1.default.setItem(constants_1.StorageKey.SAVE_PASSWORD, JSON.stringify({
                        user: "",
                        password: "",
                    }));
                }
                async_storage_1.default.setItem(constants_1.StorageKey.LOGIN_DATA, JSON.stringify(json.data));
                if (json.data?.cliente) {
                    async_storage_1.default.setItem(constants_1.StorageKey.CLIENT_DATA, JSON.stringify(json.data?.cliente));
                }
                if (json.data?.cliente?.TextoDeuda &&
                    json.data?.cliente?.MostrarDeuda == true) {
                    async_storage_1.default.setItem(constants_1.StorageKey.DEUDA, json.data?.cliente?.TextoDeuda);
                }
                callback.onSuccess(json);
                break;
            default:
                callback.onFail?.(json.msg ?? "Ha ocurrido algun error.");
                break;
        }
        callback.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback.onFail?.("Error!");
        callback.onLoading?.(false);
    });
};
exports.default = doLogin;
